const $channelSelect = document.querySelector('#channelSelect');

if ($channelSelect) {
  const $showFields = document.querySelector('.stage-channel-list__filter');
  const $submitButton = document.querySelector('.stage-channel-list__filter .list-filter__submit');
  $submitButton.removeAttribute('disabled');
  $submitButton.classList.add('list-filter__submit--active');

  $channelSelect.addEventListener('change', () => {
    const selectedValue = $channelSelect.options[$channelSelect.selectedIndex].innerHTML;
    if (selectedValue === 'Radio, TV &amp; Web') {
      $showFields.classList.remove('stage-channel-list__filter--tv', 'stage-channel-list__filter--web', 'stage-channel-list__filter--radio');
    } else if (selectedValue === 'Radio') {
      $showFields.classList.remove('stage-channel-list__filter--tv', 'stage-channel-list__filter--web');
      $showFields.classList.add('stage-channel-list__filter--radio');
    } else if (selectedValue === 'TV') {
      $showFields.classList.remove('stage-channel-list__filter--radio', 'stage-channel-list__filter--web');
      $showFields.classList.add('stage-channel-list__filter--tv');
    } else if (selectedValue === 'Web') {
      $showFields.classList.remove('stage-channel-list__filter--radio', 'stage-channel-list__filter--tv');
      $showFields.classList.add('stage-channel-list__filter--web');
    }
  });
}
